import { memo } from 'react';
import { Element, Image } from '@zmedia/bm-soccer-ui/components';
import styles from './style.module.scss';

interface IProps {
    content: string;
}
function Empty({ content = "Chưa có nội dung nào" }: IProps) {
    return (
        <Element className={styles['bm-empty']}>
            <Image src="https://baomoi-static.bmcdn.me/web/soccer/images/stadium.svg" alt="stadium"/>
            {content}
        </Element>
    );
}

export default memo(Empty);
